/* The supplier account page's own pieces: the standing line under the header and the five-tile
   strip. Tokens only (ADR-0007). The tiles are `KpiTile`s, so no figure is ever coloured here. */

.standing {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  min-width: 0;
  margin: 0;
  font-size: var(--t-min);
  color: var(--ink-2);
  line-height: 1.5;
}

.kpis {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: var(--gap);
  min-width: 0;
}

@media (width <= 1100px) {
  .kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (width <= 560px) {
  .kpis {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* A request past its due date carries an edge and a word, never colour alone. */
.overdueRow {
  padding-left: 10px;
  border-left: 3px solid var(--warn-line);
}

.metaLine {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
}
